import styled from '@emotion/styled';
import { WcpStyles } from '@workday/wcp-tokens';
import { ThemedHeading } from './ThemedHeading';

export const ThemedLabel = styled(ThemedHeading)({
  color: WcpStyles.color.text.default,
});
